/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {CustomerBundleTypeConfigContract} from '../../api/contracts/bundle-config/customer-bundle-type-config.contract';
import {CustomerBundleTypeConfigModel} from '../../models/bundle-config/customer-bundle-type-config.model';
import {CustomerBundleTypeConfigValueMapper} from './customer-bundle-type-config-value.mapper';

export class CustomerBundleTypeConfigMapper {
    static fromCustomerBundleTypeConfigContractArray(input: CustomerBundleTypeConfigContract[]):
            CustomerBundleTypeConfigModel[] {
        return input?.map((element) => CustomerBundleTypeConfigMapper.fromCustomerBundleTypeConfigContract(element));
    }

    static fromCustomerBundleTypeConfigContract(input: CustomerBundleTypeConfigContract): CustomerBundleTypeConfigModel {
        let customerBundleTypeConfigModel: CustomerBundleTypeConfigModel;
        if (input != null) {
            customerBundleTypeConfigModel = {
                bundleTypeCode: input.bundleTypeCode,
                customerCode: input.customerCode,
                configurations: CustomerBundleTypeConfigValueMapper.fromCustomerBundleTypeConfigValueContractArray(input.configurations)
            };
            return customerBundleTypeConfigModel;
        }
    }
}
